// @flow

import React from 'react';

import TrialWelcomeModalGuideView from './TrialWelcomeModalGuideView';
import TrialWelcomeModalPaymentView from './TrialWelcomeModalPaymentView';
import TrialWelcomeModalSurveyView from './TrialWelcomeModalSurveyView';
import TrialWelcomeModalTopicView from './TrialWelcomeModalTopicView';
import topics from './topics';

import { type Size } from '@zapier/design-system-company/src/types';

export type RouteProps = {
  /** The current account id (for submitting survey) */
  accountId: number,
  /** Callback to be executed when the modal is closed */
  onClose: () => void,
  /** Call to change modal route */
  onRoute: string => void,
  /** Size */
  size: Size,
};

export default {
  companyInfo: {
    Component: TrialWelcomeModalSurveyView,
  },
  guide: {
    Component: TrialWelcomeModalGuideView,
  },
  payment: {
    Component: TrialWelcomeModalPaymentView,
  },
  ...topics.reduce(
    (acc, topic) => ({
      ...acc,
      [topic.id]: {
        Component: (props: RouteProps) => (
          <TrialWelcomeModalTopicView {...topic} {...props} key={topic.id} />
        ),
      },
    }),
    {}
  ),
};
